<template>
    <section id="wrap-speaker-papers" class="mt-3">
        <div class="wrap-papers-tabs mobile-only">
            <div class="mobile-only papers-tabs justify-content-center">
                <div
                    class="mobile-tab"
                    :class="{ active: !mobileTab }"
                    @click="mobileTab = false"
                >MY PAPERS</div>
                <div
                    class="mobile-tab"
                    :class="{ active: mobileTab }"
                    @click="mobileTab = true"
                >OPEN CALLS</div>
            </div>
        </div>
        <div class="speaker-table px-2" :class="{ 'mobile-no': mobileTab }">
            <warning class="mb-3" v-for="invitation in invitations" :key="invitation.id">
                You have been invited as a co-speaker by
                <strong class="d-inline-block">
                    {{ invitation.speaker_firstname }}
                    {{ invitation.speaker_lastname }}
                </strong>
                to perform the talk
                <strong
                    class="d-inline-block"
                >{{ invitation.title }}</strong> at the
                event
                <strong
                    class="mr-2 d-inline-block"
                >{{ invitation.event_name }}</strong>
                <a
                    class="d-inline-block"
                    :href="
            `//events.codemotion.com/call-for-speakers/${
              invitation.cfp_slug
            }?paper=${invitation.id}&cospeaker=${
              invitation.cospeakers.find(el => el.email === profile.email).id
            }`
          "
                >View Paper Details</a>
            </warning>
            <mobile-filters v-model="mobileFiltersToggle">
                <div class="px-3 py-2 filter-row">
                    <h6 class>Papers:</h6>
                    <ul class="table-switch">
                        <li>
                            <button
                                @click="cospeaker = false"
                                :class="{selected: !cospeaker}"
                                class="btn btn-link"
                            >SPEAKER</button>
                        </li>
                        <li>
                            <button
                                @click="cospeaker = true"
                                :class="{selected: cospeaker}"
                                class="btn btn-link"
                            >CO-SPEAKER</button>
                        </li>
                    </ul>
                </div>
                <div class="px-3 py-2 filter-row">
                    <h6 class>Status:</h6>
                    <b-dropdown
                        class="drop-status"
                        size="sm"
                        ref="status"
                        id="status"
                        left
                        :text="papersStatus"
                    >
                        <b-dropdown-item
                            :active="activeS === 'all'"
                            @click="activePapers('all')"
                        >All</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'WAITING_FOR_APPROVAL'"
                            @click="activePapers('WAITING_FOR_APPROVAL')"
                        >In evaluation</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'APPROVED'"
                            @click="activePapers('APPROVED')"
                        >Approved</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'DRAFT'"
                            @click="activePapers('DRAFT')"
                        >Draft</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'EXPIRED'"
                            @click="activePapers('EXPIRED')"
                        >Expired</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'COSPEAKER_REFUSED'"
                            @click="activePapers('COSPEAKER_REFUSED')"
                        >Co-speaker refused</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'WAITING_FOR_COSPEAKER'"
                            @click="activePapers('WAITING_FOR_COSPEAKER')"
                        >Waiting co-speaker</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'NOT_APPROVED'"
                            @click="activePapers('NOT_APPROVED')"
                        >Not approved</b-dropdown-item>
                    </b-dropdown>
                </div>
            </mobile-filters>
            <div class="d-flex flex-wrap my-3 px-3 px-lg-0">
                <div class="d-flex mb-2 mobile-no">
                    <h6 class="mb-2 mb-md-0 d-none d-md-block">Papers:</h6>
                    <ul class="mt-3 mr-md-2 mt-md-0 table-switch">
                        <li>
                            <button
                                @click="cospeaker = false"
                                :class="{selected: !cospeaker}"
                                class="btn btn-link"
                            >SPEAKER</button>
                        </li>
                        <li>
                            <button
                                @click="cospeaker = true"
                                :class="{selected: cospeaker}"
                                class="btn btn-link"
                            >CO-SPEAKER</button>
                        </li>
                    </ul>
                    <h6 class="mb-2 mb-md-0 d-none d-md-block ml-md-2">Status:</h6>

                    <b-dropdown
                        class="order-3 order-md-1 mt-md-0 mt-3 drop-status"
                        size="sm"
                        ref="status"
                        id="status"
                        left
                        :text="papersStatus"
                    >
                        <b-dropdown-item
                            :active="activeS === 'all'"
                            @click="activePapers('all')"
                        >All</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'WAITING_FOR_APPROVAL'"
                            @click="activePapers('WAITING_FOR_APPROVAL')"
                        >In evaluation</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'APPROVED'"
                            @click="activePapers('APPROVED')"
                        >Approved</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'DRAFT'"
                            @click="activePapers('DRAFT')"
                        >Draft</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'EXPIRED'"
                            @click="activePapers('EXPIRED')"
                        >Expired</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'COSPEAKER_REFUSED'"
                            @click="activePapers('COSPEAKER_REFUSED')"
                        >Co-speaker refused</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'WAITING_FOR_COSPEAKER'"
                            @click="activePapers('WAITING_FOR_COSPEAKER')"
                        >Waiting co-speaker</b-dropdown-item>
                        <b-dropdown-item
                            :active="activeS === 'NOT_APPROVED'"
                            @click="activePapers('NOT_APPROVED')"
                        >Not approved</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div
                    class="order-2 order-md-2 ml-md-auto d-flex flex-column-reverse flex-md-row mb-2 pl-lg-2 filters-2"
                >
                    <div class="custom-search-input mt-3 mt-md-0">
                        <div class="d-flex align-items-center">
                            <input
                                type="text"
                                placeholder="Search"
                                v-model="paperSearch"
                                class="form-control"
                                v-debounce:300ms.lock="filtersChange"
                                :debounce-events="'keydown'"
                            />
                            <!-- <span
                                class="wrap-icon-search d-flex align-items-center justify-content-center p-1 mr-1"
                            >-->
                            <i class="wrap-icon-search material-icons">search</i>
                            <!-- </span> -->
                        </div>
                    </div>
                    <div
                        class="order-1 order-md-3 d-flex justify-content-md-end wrap-btn-new-paper"
                    >
                        <router-link :to="{name: 'new-paper'}" class="mt-3 mt-md-0 ml-md-3">
                            <button type="button" class="btn btn-primary btn-sm w-100">New paper</button>
                        </router-link>
                    </div>
                </div>
            </div>

            <!-- <div class="wrap-add-new-paper d-flex justify-content-center align-items-center my-2 my-md-4 mx-2 mx-lg-0 px-4 py-3">
                <a href="">Add new paper</a>
            </div>-->

            <papers-table
                type="speaker"
                :papers="papers"
                :loading="loadingPapers"
                :filtering="!loadingPapers && (activeS!=='all' || cospeaker)"
                :page="papersPage"
                :total="papersTotal"
                :perPage="papersPerPage"
                :changePage="changePage"
                @page-changed="val => (papersPage = val)"
                :cospeaker="cospeaker"
            ></papers-table>
        </div>
        <aside class="open-calls pl-lg-3" :class="{ 'mobile-no': !mobileTab }">
            <div class="title py-3 pt-4 pb-4 d-none d-lg-block">Calls for Speakers</div>
            <!-- <list-cfs type="conferences" class="mb-3 mt-1"></list-cfs> -->
            <list-cfs type="meetups"></list-cfs>
        </aside>
    </section>
</template>
<script>
import PapersTable from "@/components/Papers/PapersTable.vue";
import ListCfs from "@/components/Papers/ListCfs.vue";
import Warning from "@/components/Warning.vue";
import MobileFilters from "@/components/MobileFilters.vue";
import { differenceInDays, differenceInHours, format } from "date-fns";
export default {
    name: "MyPapers",
    components: {
        PapersTable,
        ListCfs,
        Warning,
        MobileFilters
    },
    data: () => ({
        mobileTab: false,
        activeS: "all",
        loadingPapers: false,
        papersPage: 1,
        papersTotal: 0,
        papersPerPage: 8,
        proposals: [],
        paperSearch: "",
        fields: [
            { key: "title", label: "Papers" },
            { key: "event", label: "Submitted to" },
            { key: "status", label: "" },
            { key: "actions", label: "" }
        ],
        papers: [],
        filteredProposals: [],
        cospeaker: false,
        mobileFiltersToggle: false
    }),
    computed: {
        invitations() {
            return this.$store.getters.invitations;
        },
        profile() {
            return this.$store.getters.profile;
        },
        papersStatus() {
            switch (this.activeS) {
                case "WAITING_FOR_APPROVAL":
                    return "In Evaluation";
                case "WAITING_FOR_COSPEAKER":
                    return "Waiting for Co-speaker";
                case "COSPEAKER_REFUSED":
                    return "Co-speaker Refused";
                case "APPROVED":
                    return "Approved";
                case "DRAFT":
                    return "Draft";
                case "NOT_APPROVED":
                    return "Not Approved";
                case "EXPIRED":
                    return "Expired";
                default:
                    return "All";
            }
        }
    },
    watch: {
        activeS(val) {
            this.filtersChange();
        },
        cospeaker(val) {
            this.filtersChange();
        }
    },
    methods: {
        async filtersChange() {
            this.papersPage = 1;
            if (this.cospeaker || this.activeS !== "all") {
                await this.filterProposals();
            } else {
                await this.loadPapers();
            }
        },
        getCloseDateDistance(close) {
            const now = new Date();
            close = new Date(parseInt(close));
            const distanceInHours = differenceInHours(close, now);
            if (distanceInHours > 48) {
                return differenceInDays(close, now) + " days";
            }
            return distanceInHours + " hours";
        },
        changePage(page) {
            this.papersPage = page;
            if (this.activeS !== "all" || this.cospeaker) {
                this.filterProposals();
            } else {
                this.loadPapers();
            }
        },
        async loadPapers() {
            this.loadingPapers = true;
            try {
                const papersData = await this.$papersApi.getUserPapers({
                    page: this.papersPage,
                    per_page: 8,
                    search_title: this.paperSearch
                });
                this.papers = papersData.data;
                this.papersTotal = papersData.total;
            } catch (error) {
                console.error(error);
            }
            await this.loadProposals(this.papers);
            this.loadingPapers = false;
        },
        async filterProposals() {
            this.loadingPapers = true;
            try {
                const filteredProposals = await this.$cfpApi.getUserProposals({
                    page: this.papersPage,
                    per_page: 8,
                    options: {
                        states:
                            this.activeS !== "all" ? [this.activeS] : undefined,
                        search_title: this.paperSearch,
                        only_cospeaker: this.cospeaker ? 1 : undefined
                    }
                });

                let eventsData;
                try {
                    eventsData = await this.$eventsApi.eventsList({
                        ids: [
                            ...new Set(
                                filteredProposals.data.map(el => el.event_id)
                            )
                        ]
                    });
                } catch (error) {
                    console.error(error);
                    return;
                }

                filteredProposals.data.forEach(proposal => {
                    const eName = eventsData.data.find(
                        event => event.uuid === proposal.event_id
                    );
                    proposal["event_name"] = eName ? eName.name : "";
                    proposal["organizer_name"] = eName
                        ? eName.organizer_name
                        : "";
                    proposal["cfp"] = eName ? { ...eName.cfp } : undefined;
                });

                if (!this.cospeaker) {
                    const papers = await this.$papersApi.getUserPapers({
                        ids: [
                            ...new Set(
                                filteredProposals.data.map(el => el.paper_id)
                            )
                        ]
                    });
                    this.papers = papers.data;
                    this.papers.forEach(paper => {
                        paper.proposals = [];
                        const index = filteredProposals.data.findIndex(
                            el => el.paper_id === paper.id
                        );

                        if (index >= 0) {
                            paper.proposals.push(filteredProposals.data[index]);
                            filteredProposals.data.slice(index, 1);
                        }
                    });
                    if (
                        this.papers.length < 8 &&
                        filteredProposals.total > this.papers.length
                    ) {
                        this.papersTotal = this.papers.length;
                    } else {
                        this.papersTotal = filteredProposals.total;
                    }
                } else {
                    this.papers = filteredProposals.data;
                    this.papersTotal = filteredProposals.total;
                }
            } catch (error) {
                console.error(error);
            }
            this.loadingPapers = false;
        },
        async loadProposals(papers) {
            try {
                const proposals = await this.$cfpApi.getUserProposals({
                    options: { paper_ids: papers.map(el => el.id) }
                });
                this.proposals = proposals.data;
                let eventsData;
                try {
                    eventsData = await this.$eventsApi.eventsList({
                        ids: [...new Set(this.proposals.map(el => el.event_id))]
                    });
                } catch (error) {
                    console.error(error);
                    return;
                }
                this.proposals.forEach((proposal, i) => {
                    const eName = eventsData.data.find(
                        event => event.uuid === proposal.event_id
                    );
                    if (eName) {
                        proposal["event_name"] = eName.name;
                        proposal["organizer_name"] = eName.organizer_name;
                        proposal["cfp"] = { ...eName.cfp };
                    } else {
                        this.proposals.splice(i, 1);
                    }
                });
            } catch (error) {
                console.error(error);
            }
            if (this.proposals.length) {
                this.papers.forEach(paper => {
                    let index;
                    paper.proposals = [];
                    do {
                        index = this.proposals.findIndex(
                            el => el.paper_id === paper.id
                        );
                        if (index >= 0) {
                            paper.proposals.push(this.proposals[index]);
                            this.proposals.splice(index, 1);
                        }
                    } while (index >= 0);
                });
            }
        },

        activePapers(status) {
            this.activeS = status;
        }
    },
    async mounted() {
        this.loadPapers();
    }
};
</script>
<style lang="scss">
@import "@/assets/scss/_common.scss";
#wrap-speaker-papers {
    .dropdown {
        .dropdown-toggle {
            color: $palette-orange !important;
            background-color: #ededed !important;
            border-color: transparent !important;
            padding: 3.2px 10px;
            &:hover {
                color: $palette-orange !important;
                background-color: #ededed !important;
                border-color: transparent !important;
            }
        }
        .btn {
            min-width: unset;
        }
    }
    //     position: relative;
    //     .btn-overlay {
    //         z-index: 10;
    //         position: absolute;
    //         height: 100%;
    //         width: 25px;
    //         right: 0;
    //         background: rgb(237, 237, 237);
    //         background: linear-gradient(
    //             270deg,
    //             rgba(237, 237, 237, 1) 44%,
    //             rgba(248, 248, 248, 0) 58%
    //         );
    //     }
    // }

    h6 {
        line-height: 2;
        margin-right: 10px;
        font-weight: 500;
        float: left;
        margin-bottom: 0;
    }

    .drop-status {
        width: 100%;
        text-transform: uppercase;
    }
    @media all and (min-width: 576px) {
        .drop-status {
            width: auto;
        }
    }

    .dropdown-menu.show {
        // width: 100%;
        text-align: center;
        @media all and (min-width: 576px) {
            width: auto;
            text-align: left;
        }
    }

    .custom-search-input {
        border-radius: 30px;
        background-color: #ededed;
        width: 100%;
        position: relative;
        @media all and (min-width: 768px) {
            width: 115px;
        }
    }

    .custom-search-input input {
        border: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        background-color: #ededed;
        border-radius: 30px;
        height: 32px;
        font-weight: 600;
        font-size: 14px;
        color: $palette-blue;
        padding-right: 30px;
    }

    .wrap-icon-search {
        cursor: pointer;
        border-radius: 50%;
        height: 100%;
        position: absolute;
        right: 5px;
        display: flex;
        align-items: center;
        color: #ff5c00;

    }
    .dropdown-item {
        text-transform: uppercase;
    }
    .dropdown-toggle {
        padding: 0.2rem 1rem;
    }

    .wrap-papers-tabs {
        border-bottom: 1px solid #ededed;
        width: 100%;
    }
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
#wrap-speaker-papers {
    display: flex;
    // padding-top: 40px;
    // padding: 15px;
    @media all and (max-width: 990px) {
        flex-direction: column;
        align-items: center;
        padding-top: 0;

        .papers-tabs {
            display: flex !important;
            width: 100%;
            // margin-bottom: 10px;
            padding: 0 10px;
            border-bottom: 1px solid #ededed;
            .mobile-tab {
                width: auto;
                text-align: center;
                border-bottom: 2px solid transparent;
                transition: all 0.5s ease;
                padding: 10px 15px;
                cursor: pointer;
                font-weight: 600;
            }
            .active {
                color: #ff5c00;
                border-color: #ff5c00;
            }
        }

        aside {
            padding: 10px;
        }
    }
    max-width: 1440px;
    margin: 0 auto;

    ul.table-switch {
        display: flex;
        list-style: none;
        padding: 0;
        justify-content: center;
        background: #ededed;
        border-radius: 30px;
        border-radius: 30px;
        opacity: 1;
        transition: all 0.5s ease;

        &::before {
            width: 32px;
            height: 32px;
            content: "";
            display: inline-block;
            border-radius: 50%;
            background: #ededed;
            margin-right: -16px;
        }
        &::after {
            width: 32px;
            height: 32px;
            content: "";
            display: inline-block;
            border-radius: 50%;
            background: #ededed;
            margin-left: -16px;
        }
        li {
            background: #ededed;
            height: 32px;
            &:last-child {
                button.btn.btn-link {
                    border-right: none;
                    padding-right: 0;
                }
            }
            &:first-child {
                button.btn.btn-link {
                    padding-left: 0;
                }
            }
            button.btn.btn-link {
                padding: 0 10px;
                font-size: 14px;
                line-height: 1;
                border-right: 1px solid #a9a9a9;
                border-radius: 0;
                margin: 8px 0;
                color: $black;
                min-width: auto;
                border-bottom: 0;
                text-decoration: none;
                &.selected,
                &:hover {
                    color: $orange;
                }
                &:focus {
                    text-decoration: none;
                    border-bottom: 0;
                }
            }
        }
    }

    .speaker-table,
    .open-calls {
        width: 100%;
        .title {
            font-size: 16px;
        }
    }
    @media all and (min-width: 991px) {
        .speaker-table {
            width: 70%;
        }
        .open-calls {
            width: 30%;
        }
    }

    .wrap-add-new-paper {
        background: #ffffff;
        border: 1px solid #b3b3b3;
        border-radius: 5px;
        border: 1px dashed #b3b3b3;
    }

    .wrap-btn-new-paper {
        width: 100%;
        @media all and (min-width: 768px) {
            width: auto;
        }
        & > a {
            width: 100%;
            @media all and (min-width: 768px) {
                width: auto;
            }
        }
    }

    .filters-2 {
        width: 100%;

        @media all and (min-width: 768px) {
            width: auto;
        }
    }

    .filter-status-mobile {
        .filter-row {
            width: 100%;
            max-width: 390px;
            display: flex;
            margin: 5px 0;
            align-items: center;
            h6 {
                width: 20%;
            }
            .drop-status {
                width: auto;
            }
        }
    }
}
</style>
